<mat-card appearance="outlined" class="card">
  <mat-card-mdc-header>
    <mat-card-title>
      <h4 class="card-title">
        <mat-icon *ngIf="data?.icon">{{data?.icon}}</mat-icon>
        {{data?.title}}
      </h4>
    </mat-card-title>
  </mat-card-mdc-header>
  <mat-mdc-card-content>
    <div>{{data?.description}}</div>
    <div class="message-field">
        {{data?.question}}
        <mat-progress-bar  mode="indeterminate" *ngIf="wait"></mat-progress-bar>
    </div>
  </mat-mdc-card-content>
  <mat-card-actions class="tar">
    <button mat-raised-button color="primary" [disabled]="wait" (click)="onConfirm()">{{data?.confirmTxt}}</button>
    <button mat-raised-button mat-dialog-close color="primary" [disabled]="wait">{{data?.cancelTxt}}</button>
  </mat-card-actions>
</mat-card>